<template>
    <v-layout v-if="!bucketLoading">
      <v-flex class="mt-3 mb-0 px-0 py-0">
      <v-flex px-4 >
        <v-card-title class="ma-0 mb-2 pa-0">
          <h3>Group by <strong>{{field}} </strong></h3>
        </v-card-title>
       <v-radio-group row v-model="activeStat">
        <v-radio
          v-for="(kpi, index) in availableStatistcs"
          :key="index"
          :label="kpiLabel(kpi)"
          :value="index"
          color="secondary"
        />
      </v-radio-group>
      </v-flex>
      <v-divider class="mb-0 mt-2"></v-divider>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
export default {
  name: "BucketKPIs",
  data: () => ({
    activeStat: 0
  }), // -1 = Unselected
  computed: {
    ...mapState({
      statistics: state =>
        state.buckets.current.bucket &&
      state.buckets.current.bucket.contents &&
      state.buckets.current.bucket.contents.statistics
          ? state.buckets.current.bucket.contents.statistics
          : { kpis: [], total: 0, totalCreated24hrs: 0, totalUpdated24hrs: 0 },
      currentField: state =>
        state.buckets.current.bucket &&
      state.buckets.current.bucket.kpi
          ? state.buckets.current.bucket.kpi
          : "current_state",
      bucketLoading: state =>
        state.buckets.current &&
      state.buckets.current.loading
          ? state.buckets.current.loading
          : false
    }),
    availableStatistcs() {
      return [{ key: 'Show all', value: undefined }].concat(this.statistics.kpis)
    },
    field() {
      if (this.currentField) {
        return Helpers.capitalizeRemoveUnderscores(this.currentField)
      } else {
        return ""
      }
    }
  },
  watch: {
    activeStat() {
      if (this.activeStat > 0) {
        this.$emit("stat-selected", {
          field: this.currentField,
          kpi: this.statistics.kpis[this.activeStat - 1]
        })
      } else {
        this.$emit("stat-cleared")
      }
    }
  },
  methods: {
    setActive(index) {
      if (this.activeStat === index) {
        this.activeStat = -1
      } else {
        this.activeStat = index
      }
    },
    kpiLabel(kpi) {
      if (!kpi) return ""
      return kpi.value ? `${kpi.key} (${kpi.value})` : kpi.key
    },
    isSelected(index) {
      return this.activeStat === index
    }
  }
}
</script>
